export enum SystemMessageType {
    ApplicationStateChange,
    NewFilterSet,
    ExistingFilterSet,
    RegenerateSuggestions,
}

export type SystemMessageContext = Record<PropertyKey, unknown>;

export interface ISystemMessageTemplate {
    readonly id: string;
    readonly type: SystemMessageType;
    readonly template: string;
    readonly withPayload?: boolean;
    readonly resetMessages?: boolean;
}

export interface ISystemMessage {
    readonly type: SystemMessageType;
    readonly content: string;
}

type SystemMessageHandler = (context?: SystemMessageContext) => string;

export interface ISystemMessageConfig {
    readonly type: SystemMessageType;
    readonly handler: SystemMessageHandler;
    readonly resetMessages?: boolean;
    readonly withPayload?: boolean;
}
